// Plain constants only: the public planner bundle imports this, so it must never pull in
// src/config.js or anything that touches auth or localStorage.
export const LAYOUT_HELP_ARTICLE_URL = 'https://chain-help.freshdesk.com/support/solutions/articles/206000122868'
